export default __webpack_public_path__ + "static/oilfields_bunker-340a1c51a863efb05d73deffbce69bfc.png";